import { CompanyIdentifier } from "@/enums/dataMerch";
import i18n from "@/i18n";

const t = i18n.global.t;

export const companyIdentifierOptions: Record<CompanyIdentifier, string> = {
  [CompanyIdentifier.EIN]: t("COMMON.EIN"),
  [CompanyIdentifier.COMPANY_NAME]: t("DEALS.EXPERIAN_GDN.COMPANY_NAME"),
};
